<template>
  <div>
    <Banner></Banner>
  </div> 
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/BannerComponent.vue'

export default {
  name: 'home',
  components: {
    Banner
  }
}
</script>
